import { useEffect } from "react";

const VCARD = `BEGIN:VCARD\nVERSION:3.0\nFN:Juan Luis Fainer\nN:Fainer;Juan Luis;;;\nORG:Faro Energía\nTITLE:Consultor Energético\nTEL;TYPE=CELL:+34657891882\nEMAIL;TYPE=WORK:jl.fainer@faroenergia.es\nURL:https://faroenergia.es\nADR;TYPE=WORK:;;Castellón de la Plana / Barcelona;;;;\nNOTE:Consultor Energético de Faro Energía\nEND:VCARD`;

function downloadVCard() {
  const blob = new Blob([VCARD], { type: "text/vcard;charset=utf-8" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = "JuanLuis_Fainer_FaroEnergia.vcf";
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}

export default function JuanluCard() {
  useEffect(() => {
    document.title = "Juan Luis Fainer – Consultor Energético | Faro Energía";
  }, []);

  return (
    <div
      className="min-h-screen flex items-center justify-center px-4 py-10"
      style={{ background: "linear-gradient(135deg, #e8f9f6 0%, #fff5eb 100%)" }}
    >
      {/* Card */}
      <div className="bg-white rounded-2xl w-full max-w-[480px] overflow-hidden"
        style={{ boxShadow: "0 10px 40px rgba(0,0,0,0.10)" }}
      >

        {/* Header gradient */}
        <div
          className="h-36 flex items-center justify-center px-5"
          style={{ background: "linear-gradient(90deg, #1fb5a8 0%, #f39c12 100%)" }}
        >
          <img
            src="https://public.readdy.ai/ai/img_res/73dfd2d3-6ecc-4d20-afd5-49901dbfd111.png"
            alt="Faro Energía"
            className="h-20 w-auto object-contain brightness-0 invert"
          />
        </div>

        {/* Profile */}
        <div className="text-center px-5 pt-0 pb-5">
          {/* Photo — pulled up over header */}
          <div className="flex justify-center">
            <div
              className="w-28 h-28 rounded-xl border-4 border-white overflow-hidden -mt-8 relative z-10"
              style={{ boxShadow: "0 4px 12px rgba(0,0,0,0.15)" }}
            >
              <img
                src="https://storage.readdy-site.link/project_files/a340218b-9c12-48df-b534-4ebb92bf6973/fb78b3c9-b88b-4305-a76b-f43dbcc3c47e_Foto-Jaunlu_Faro.jpeg?v=936426141d6a0958a0ba6faf37db23e2"
                alt="Juan Luis Fainer"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>

          <h1 className="text-[22px] font-semibold text-gray-900 mt-4 mb-1 leading-tight">
            Juan Luis Fainer
          </h1>
          <p className="text-sm font-medium" style={{ color: "#1fb5a8" }}>
            Consultor Energético
          </p>
          <p className="text-sm text-gray-500 mt-0.5">Faro Energía</p>
        </div>

        {/* Divider */}
        <div className="h-px bg-gray-100 mx-5" />

        {/* Contact info */}
        <div className="px-5 py-5 flex flex-col gap-3">
          <a
            href="tel:+34657891882"
            className="flex items-center gap-3 text-sm text-gray-700 cursor-pointer hover:text-[#1fb5a8] transition-colors duration-200 group"
          >
            <span className="w-5 h-5 flex items-center justify-center flex-shrink-0" style={{ color: "#1fb5a8" }}>
              <i className="ri-phone-line text-base" />
            </span>
            657 89 18 82
          </a>

          <a
            href="mailto:jl.fainer@faroenergia.es"
            className="flex items-center gap-3 text-sm text-gray-700 cursor-pointer hover:text-[#1fb5a8] transition-colors duration-200"
          >
            <span className="w-5 h-5 flex items-center justify-center flex-shrink-0" style={{ color: "#1fb5a8" }}>
              <i className="ri-mail-line text-base" />
            </span>
            jl.fainer@faroenergia.es
          </a>

          <a
            href="https://faroenergia.es"
            target="_blank"
            rel="nofollow noreferrer"
            className="flex items-center gap-3 text-sm text-gray-700 cursor-pointer hover:text-[#1fb5a8] transition-colors duration-200"
          >
            <span className="w-5 h-5 flex items-center justify-center flex-shrink-0" style={{ color: "#1fb5a8" }}>
              <i className="ri-global-line text-base" />
            </span>
            faroenergia.es
          </a>

          <div className="flex items-center gap-3 text-sm text-gray-700">
            <span className="w-5 h-5 flex items-center justify-center flex-shrink-0" style={{ color: "#1fb5a8" }}>
              <i className="ri-map-pin-line text-base" />
            </span>
            Castellón de la Plana · Barcelona
          </div>
        </div>

        {/* Divider */}
        <div className="h-px bg-gray-100 mx-5" />

        {/* Action buttons */}
        <div className="px-5 py-5 flex flex-col gap-3">
          {/* Save contact — primary */}
          <button
            onClick={downloadVCard}
            className="w-full flex items-center justify-center gap-2.5 text-white text-sm font-semibold py-3.5 rounded-lg transition-all duration-200 cursor-pointer whitespace-nowrap active:scale-95"
            style={{ background: "#1fb5a8" }}
            onMouseEnter={e => (e.currentTarget.style.background = "#18a399")}
            onMouseLeave={e => (e.currentTarget.style.background = "#1fb5a8")}
          >
            <span className="w-5 h-5 flex items-center justify-center">
              <i className="ri-user-add-line text-base" />
            </span>
            Guardar contacto
          </button>

          {/* Call + WhatsApp row */}
          <div className="grid grid-cols-2 gap-3">
            <a
              href="tel:+34657891882"
              className="flex items-center justify-center gap-2 text-white text-sm font-semibold py-3.5 rounded-lg transition-all duration-200 cursor-pointer whitespace-nowrap active:scale-95"
              style={{ background: "#1fb5a8" }}
              onMouseEnter={e => (e.currentTarget.style.background = "#18a399")}
              onMouseLeave={e => (e.currentTarget.style.background = "#1fb5a8")}
            >
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-phone-fill text-sm" />
              </span>
              Llamar
            </a>
            <a
              href="https://wa.me/34657891882?text=Hola%20Juan%20Luis%2C%20me%20gustar%C3%ADa%20conocer%20m%C3%A1s%20sobre%20Faro%20Energ%C3%ADa"
              target="_blank"
              rel="nofollow noreferrer"
              className="flex items-center justify-center gap-2 text-white text-sm font-semibold py-3.5 rounded-lg transition-all duration-200 cursor-pointer whitespace-nowrap active:scale-95"
              style={{ background: "#27ae60" }}
              onMouseEnter={e => (e.currentTarget.style.background = "#229954")}
              onMouseLeave={e => (e.currentTarget.style.background = "#27ae60")}
            >
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-whatsapp-line text-sm" />
              </span>
              WhatsApp
            </a>
          </div>

          {/* Email — outline */}
          <a
            href="mailto:jl.fainer@faroenergia.es"
            className="w-full flex items-center justify-center gap-2.5 bg-transparent text-sm font-semibold py-3.5 rounded-lg border-2 transition-all duration-200 cursor-pointer whitespace-nowrap active:scale-95 hover:bg-[#f0fffe]"
            style={{ color: "#1fb5a8", borderColor: "#1fb5a8" }}
          >
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-mail-send-line text-sm" />
            </span>
            Enviar email
          </a>
        </div>

        {/* Footer */}
        <div className="bg-gray-50 px-5 py-4 text-center">
          <p className="text-xs text-gray-400">
            Faro Energía · Consultoría Energética Independiente
          </p>
        </div>
      </div>
    </div>
  );
}
